module.exports = __webpack_public_path__ + "static/messenger-img-7eaad9ee7591e4c096e1e0ee9d96e516.jpeg";